export const BULK_SELECTION_AREA_ID = 'bulk-selection-area';
export const BULK_PREVENT_CLASSNAME = 'bulk-action';
